// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/cnidarium/v1/cnidarium.proto (package penumbra.cnidarium.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { MerkleProof } from "@buf/cosmos_ibc.bufbuild_es/ibc/core/commitment/v1/commitment_pb.js";

/**
 * Performs a key-value query against the nonverifiable storage,
 * using a byte-encoded key.
 *
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueRequest
 */
export const NonVerifiableKeyValueRequest = proto3.makeMessageType(
  "penumbra.cnidarium.v1.NonVerifiableKeyValueRequest",
  () => [
    { no: 1, name: "key", kind: "message", T: NonVerifiableKeyValueRequest_Key },
  ],
);

/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueRequest.Key
 */
export const NonVerifiableKeyValueRequest_Key = proto3.makeMessageType(
  "penumbra.cnidarium.v1.NonVerifiableKeyValueRequest.Key",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
  {localName: "NonVerifiableKeyValueRequest_Key"},
);

/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueResponse
 */
export const NonVerifiableKeyValueResponse = proto3.makeMessageType(
  "penumbra.cnidarium.v1.NonVerifiableKeyValueResponse",
  () => [
    { no: 1, name: "value", kind: "message", T: NonVerifiableKeyValueResponse_Value },
  ],
);

/**
 * @generated from message penumbra.cnidarium.v1.NonVerifiableKeyValueResponse.Value
 */
export const NonVerifiableKeyValueResponse_Value = proto3.makeMessageType(
  "penumbra.cnidarium.v1.NonVerifiableKeyValueResponse.Value",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
  {localName: "NonVerifiableKeyValueResponse_Value"},
);

/**
 * Performs a key-value query against the JMT, either by key or by key hash.
 *
 * Proofs are only supported by key.
 *
 * @generated from message penumbra.cnidarium.v1.KeyValueRequest
 */
export const KeyValueRequest = proto3.makeMessageType(
  "penumbra.cnidarium.v1.KeyValueRequest",
  () => [
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "proof", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message penumbra.cnidarium.v1.KeyValueResponse
 */
export const KeyValueResponse = proto3.makeMessageType(
  "penumbra.cnidarium.v1.KeyValueResponse",
  () => [
    { no: 1, name: "value", kind: "message", T: KeyValueResponse_Value },
    { no: 2, name: "proof", kind: "message", T: MerkleProof },
  ],
);

/**
 * @generated from message penumbra.cnidarium.v1.KeyValueResponse.Value
 */
export const KeyValueResponse_Value = proto3.makeMessageType(
  "penumbra.cnidarium.v1.KeyValueResponse.Value",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
  {localName: "KeyValueResponse_Value"},
);

/**
 * Performs a prefixed key-value query, by string prefix.
 *
 * @generated from message penumbra.cnidarium.v1.PrefixValueRequest
 */
export const PrefixValueRequest = proto3.makeMessageType(
  "penumbra.cnidarium.v1.PrefixValueRequest",
  () => [
    { no: 2, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.cnidarium.v1.PrefixValueResponse
 */
export const PrefixValueResponse = proto3.makeMessageType(
  "penumbra.cnidarium.v1.PrefixValueResponse",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Requests a stream of new key-value pairs that have been committed to the state.
 *
 * @generated from message penumbra.cnidarium.v1.WatchRequest
 */
export const WatchRequest = proto3.makeMessageType(
  "penumbra.cnidarium.v1.WatchRequest",
  () => [
    { no: 1, name: "key_regex", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nv_key_regex", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * A key-value pair that has been committed to the state.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse
 */
export const WatchResponse = proto3.makeMessageType(
  "penumbra.cnidarium.v1.WatchResponse",
  () => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "kv", kind: "message", T: WatchResponse_KeyValue, oneof: "entry" },
    { no: 6, name: "nv_kv", kind: "message", T: WatchResponse_NvKeyValue, oneof: "entry" },
  ],
);

/**
 * Elements of the verifiable storage have string keys.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse.KeyValue
 */
export const WatchResponse_KeyValue = proto3.makeMessageType(
  "penumbra.cnidarium.v1.WatchResponse.KeyValue",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "WatchResponse_KeyValue"},
);

/**
 * Elements of the nonverifiable storage have byte keys.
 *
 * @generated from message penumbra.cnidarium.v1.WatchResponse.NvKeyValue
 */
export const WatchResponse_NvKeyValue = proto3.makeMessageType(
  "penumbra.cnidarium.v1.WatchResponse.NvKeyValue",
  () => [
    { no: 1, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "WatchResponse_NvKeyValue"},
);

